import { SVGAttributes, VFC } from "react";

/* eslint-disable react/require-default-props */
const ChevronRight: VFC<SVGAttributes<SVGElement>> = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.70718 1.29285L9.41429 5.99995L4.70718 10.7071L3.29297 9.29285L6.58586 5.99995L3.29297 2.70706L4.70718 1.29285Z"
        fill="#191817"
        fillOpacity="0.75"
        {...props}
      />
    </svg>
  );
};

export { ChevronRight };
